module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2-56e4871fbd53c63f2a77602d35849e4c.webp";